// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__Z0jxO","subheader":"ReorderModal_subheader__2Y-ei","listWrap":"ReorderModal_listWrap__7esig"};